import { CardFases } from "./CardFases";

export function Fases({ data, apenasAtrasados, unidadeId }) {
  return (
    <div className="grid grid-cols-3 gap-4">

      <CardFases label="Pendente" solicitacoes={data?.data_pendentes} unidadeId={unidadeId} />
      <CardFases label="Em atendimento" solicitacoes={data?.data_em_andamento} unidadeId={unidadeId} />
      {!apenasAtrasados && <CardFases label="Concluídos" solicitacoes={data?.data_finalizadas} />}

    </div>
  )
}